const PeculiarContentHub = () => {
  const selectors = {
    section: ".js-peculiar-content-hub",
    slider: ".js-peculiar-content-hub-slider",
    prevButton: ".js-peculiar-content-hub-button-prev",
    nextButton: ".js-peculiar-content-hub-button-next"
  };

  function init(sectionId) {
    const sections = [...document.querySelectorAll(selectors.section)].filter(
      (section) => !sectionId || section.closest(`#shopify-section-${sectionId}`)
    );

    sections.forEach((section) => {
      const slider = section.querySelector(selectors.slider);

      if (!slider || slider.swiper) {
        return;
      }

      const Swiper = window.themeCore.utils.Swiper;

      new Swiper(slider, {
        slidesPerView: 1.2,
        spaceBetween: 14,
        grabCursor: true,
        watchOverflow: true,
        navigation: {
          prevEl: section.querySelector(selectors.prevButton),
          nextEl: section.querySelector(selectors.nextButton)
        },
        breakpoints: {
          374: {
            slidesPerView: 1.6,
            spaceBetween: 16
          },
          576: {
            slidesPerView: 2.25,
            spaceBetween: 16
          },
          768: {
            slidesPerView: 2.75,
            spaceBetween: 20
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 22
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 22
          }
        }
      });
    });
  }

  return Object.freeze({ init });
};

const action = () => {
  window.themeCore.PeculiarContentHub =
    window.themeCore.PeculiarContentHub || PeculiarContentHub();
  window.themeCore.utils.register(window.themeCore.PeculiarContentHub, "peculiar-content-hub");
};

if (window.themeCore && window.themeCore.loaded) {
  action();
} else {
  document.addEventListener("theme:all:loaded", action, { once: true });
}
